import React from "react";

const avatarOptions = [
    "/avatars/avatar1.png",
    "/avatars/avatar2.png",
    "/avatars/avatar3.png",
    "/avatars/avatar4.png",
    "/avatars/avatar5.png",
    "/avatars/avatar6.png",
    "/avatars/avatar7.png",
    "/avatars/avatar8.png",
    "/avatars/avatar9.png",
    "/avatars/avatar10.png",
    "/avatars/avatar11.png",
    "/avatars/avatar12.png",
    "/avatars/avatar13.png",
    "/avatars/avatar14.png",
    "/avatars/avatar15.png",
    "/avatars/avatar16.png",
    "/avatars/avatar17.png",
    "/avatars/avatar18.png",
    "/avatars/avatar19.png",
    "/avatars/avatar20.png",
    "/avatars/avatar21.png",
    "/avatars/avatar22.png",
    "/avatars/avatar23.png",
    "/avatars/avatar24.png",
    "/avatars/avatar25.png",
];

const AvatarPicker = ({ selectedAvatar, onSelect }) => {
    return (
        <div className="avatar-grid">
            {avatarOptions.map((url) => (
                <div
                    key={url}
                    onClick={() => onSelect(url)}
                    className={`avatar-option ${selectedAvatar === url ? "selected" : ""}`}
                    style={{ cursor: "pointer" }}
                >
                    <img
                        src={url}
                        alt="Аватарка"
                        style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "cover" }}
                    />
                </div>
            ))}
        </div>

    );
};

export default AvatarPicker;
